// Product gallery: one scroll-snap track, thumbnail buttons that jump to a slide,
// active-thumb tracking, and a jump to the selected variant's image.
class SProductGallery extends HTMLElement {
  #ac;
  #track;
  #thumbs = [];
  #variantMedia = {};
  #frame = 0;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };
    this.#track = this.querySelector('[data-gallery-track]');
    this.#thumbs = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    try {
      this.#variantMedia = JSON.parse(this.querySelector('[data-variant-media]')?.textContent || '{}');
    } catch {
      this.#variantMedia = {};
    }
    if (!this.#track) return;

    this.#thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.#goTo(Number(thumb.dataset.galleryThumb)), opts);
    });

    this.#track.addEventListener('scroll', () => {
      cancelAnimationFrame(this.#frame);
      this.#frame = requestAnimationFrame(() => this.#syncActive());
    }, { ...opts, passive: true });

    // Variant options anywhere on the page carry data-variant-id; follow them to that variant's image.
    document.addEventListener('change', (event) => {
      const input = event.target;
      const variantId = input?.dataset?.variantId || input?.selectedOptions?.[0]?.dataset?.variantId;
      if (!variantId) return;
      const mediaId = this.#variantMedia[variantId];
      if (!mediaId) return;
      const slide = this.#track.querySelector(`[data-media-id="${mediaId}"]`);
      if (slide) this.#goTo(Array.from(this.#track.children).indexOf(slide));
    }, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
    cancelAnimationFrame(this.#frame);
  }

  #goTo(index) {
    const slide = this.#track.children[index];
    if (!slide) return;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.#track.scrollTo({ left: slide.offsetLeft - this.#track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    this.#setActive(index);
  }

  #syncActive() {
    const width = this.#track.clientWidth || 1;
    const index = Math.round(Math.abs(this.#track.scrollLeft) / width);
    this.#setActive(index);
  }

  #setActive(index) {
    this.#thumbs.forEach((thumb, i) => thumb.setAttribute('aria-current', String(i === index)));
  }
}

if (!customElements.get('s-product-gallery')) customElements.define('s-product-gallery', SProductGallery);
